import { gql } from 'graphql-request';

// Sprint 17, story-082. Same shape subscription.queries.tsx's PlanAddonSummaryFields declares —
// kept as a separate fragment here (not imported cross-file) since this file's own convention is
// self-contained fragments per query file.
export const PLAN_ADDON_SUMMARY_FIELDS = gql`
  fragment PlanAddonSummaryFieldsAdmin on PlanAddonSummaryDto {
    id
    name
    includedSeats
    priceCents
  }
`;

// Fragment for reusable fields
export const SUBSCRIPTION_PLAN_FIELDS = gql`
  fragment SubscriptionPlanFields on SubscriptionPlanTemplateDto {
    id
    name
    payMethod
    basePriceCents
    includedSeats
    isPublic
    isAddOn
    seatCountingRoles
    trialDurationDays
    requiresPaymentUpfront
    validFrom
    validTo
    createdAt
    updatedAt
    addOns {
      ...PlanAddonSummaryFieldsAdmin
    }
  }
  ${PLAN_ADDON_SUMMARY_FIELDS}
`;

// Query: Get all subscription plans (Admin - includes add-ons)
export const GET_ALL_SUBSCRIPTION_PLANS = gql`
  query getAllSubscriptionPlans {
    getAllSubscriptionPlans {
      ...SubscriptionPlanFields
    }
  }
  ${SUBSCRIPTION_PLAN_FIELDS}
`;

// Query: Get subscription plan by ID
export const GET_SUBSCRIPTION_PLAN_BY_ID = gql`
  query getSubscriptionPlanById($planId: String!) {
    getSubscriptionPlanById(planId: $planId) {
      ...SubscriptionPlanFields
    }
  }
  ${SUBSCRIPTION_PLAN_FIELDS}
`;

// Mutation: Create subscription plan
export const CREATE_SUBSCRIPTION_PLAN = gql`
  mutation createSubscriptionPlan($input: CreateSubscriptionPlanInput!) {
    createSubscriptionPlan(input: $input) {
      ...SubscriptionPlanFields
    }
  }
  ${SUBSCRIPTION_PLAN_FIELDS}
`;

// Mutation: Update subscription plan
export const UPDATE_SUBSCRIPTION_PLAN = gql`
  mutation updateSubscriptionPlan($planId: String!, $input: UpdateSubscriptionPlanInput!) {
    updateSubscriptionPlan(planId: $planId, input: $input) {
      ...SubscriptionPlanFields
    }
  }
  ${SUBSCRIPTION_PLAN_FIELDS}
`;

// Mutation: Delete subscription plan
export const DELETE_SUBSCRIPTION_PLAN = gql`
  mutation deleteSubscriptionPlan($planId: String!) {
    deleteSubscriptionPlan(planId: $planId)
  }
`;

// Sprint 17, story-082 — SUPER_ADMIN only: link/unlink/reprice an add-on on a base plan.
export const LINK_ADDON_TO_PLAN = gql`
  mutation linkAddonToPlan($planId: String!, $addonId: String!, $priceCents: Int!) {
    linkAddonToPlan(planId: $planId, addonId: $addonId, priceCents: $priceCents) {
      ...PlanAddonSummaryFieldsAdmin
    }
  }
  ${PLAN_ADDON_SUMMARY_FIELDS}
`;

export const UNLINK_ADDON_FROM_PLAN = gql`
  mutation unlinkAddonFromPlan($planId: String!, $addonId: String!) {
    unlinkAddonFromPlan(planId: $planId, addonId: $addonId)
  }
`;

export const REPRICE_ADDON_LINK = gql`
  mutation repriceAddonLink($planId: String!, $addonId: String!, $priceCents: Int!) {
    repriceAddonLink(planId: $planId, addonId: $addonId, priceCents: $priceCents) {
      ...PlanAddonSummaryFieldsAdmin
    }
  }
  ${PLAN_ADDON_SUMMARY_FIELDS}
`;

// Grouped export
export const SubscriptionPlanGraphQL = {
  fragments: {
    SUBSCRIPTION_PLAN_FIELDS,
    PLAN_ADDON_SUMMARY_FIELDS,
  },
  queries: {
    GET_ALL_SUBSCRIPTION_PLANS,
    GET_SUBSCRIPTION_PLAN_BY_ID,
  },
  mutations: {
    CREATE_SUBSCRIPTION_PLAN,
    UPDATE_SUBSCRIPTION_PLAN,
    DELETE_SUBSCRIPTION_PLAN,
    LINK_ADDON_TO_PLAN,
    UNLINK_ADDON_FROM_PLAN,
    REPRICE_ADDON_LINK,
  },
};
